export class InvalidRecoveryCodeError extends Error {
  constructor() {
    super('Invalid or code has already been used.')
    Object.setPrototypeOf(this, InvalidRecoveryCodeError.prototype)
  }
}
